export const codigos = [
  {
    codigo: 1,
  },
  {
    codigo: 2,
  },
  {
    codigo: 3,
  },
  {
    codigo: 4,
  },
  {
    codigo: 5,
  },
  {
    codigo: 6,
  },
  {
    codigo: 7,
  },
  {
    codigo: 8,
  },
  {
    codigo: 9,
  },
  {
    codigo: 10,
  },
  {
    codigo: 11,
  },
  {
    codigo: 12,
  },
  {
    codigo: 13,
  },
  {
    codigo: 14,
  },
  {
    codigo: 15,
  },
  {
    codigo: 16,
  },
  {
    codigo: 17,
  },
  {
    codigo: 18,
  },
  {
    codigo: 19,
  },
  {
    codigo: 20,
  },
  {
    codigo: 21,
  },
  {
    codigo: 22,
  },
  {
    codigo: 23,
  },
  {
    codigo: 24,
  },
  {
    codigo: 25,
  },
  {
    codigo: 26,
  },
  {
    codigo: 27,
  },
  {
    codigo: 28,
  },
  {
    codigo: 29,
  },
  {
    codigo: 30,
  },
];

const tipoConta = [
  {
    id: 'CORRENTE',
    descricao: 'Corrente',
  },
  {
    id: 'POUPANCA',
    descricao: 'Poupança',
  },
];

const SLOGAN_AGROGER = 'Agroger - O software do cafeicultor';

const PRODUTO_CAFE_ID = 100;
const PRODUTO_GOIABA_ID = 103;
const PRODUCT_CAFE_ID = 1;

export {
  tipoConta,
  SLOGAN_AGROGER,
  PRODUTO_CAFE_ID,
  PRODUCT_CAFE_ID,
  PRODUTO_GOIABA_ID,
};
